export default "__VITE_ASSET__8094353b__"